import { DependencyList, useCallback } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

import { PlayerAdapter } from '../types/instance';

export const useInstanceCallback = <CallbackArgsType extends unknown[], CallbackReturnType>(
    callback: (instance: PlayerAdapter | null, ...args: CallbackArgsType) => CallbackReturnType,
    dependencies: DependencyList = []
) => {
    const instance = usePlayerInstance();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(callback.bind(null, instance), [instance, ...dependencies]);
};
